import { render, staticRenderFns } from "./NotificationsPool.vue?vue&type=template&id=3a2b4868"
import script from "./NotificationsPool.vue?vue&type=script&lang=js"
export * from "./NotificationsPool.vue?vue&type=script&lang=js"
import style0 from "./NotificationsPool.vue?vue&type=style&index=0&id=3a2b4868&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports